"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useLink_unstable", {
    enumerable: true,
    get: ()=>useLink_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const _useLinkState = require("./useLinkState");
const useLink_unstable = (props, ref)=>{
    const { appearance ='default' , disabled =false , disabledFocusable =false , inline =false  } = props;
    const as = props.as || (props.href ? 'a' : 'button');
    const type = as === 'button' ? 'button' : undefined;
    const state = {
        // Props passed at the top-level
        appearance,
        disabled,
        disabledFocusable,
        inline,
        // Slots definition
        components: {
            root: 'a'
        },
        root: (0, _reactUtilities.getNativeElementProps)(as, {
            ref,
            type,
            ...props,
            as
        })
    };
    (0, _useLinkState.useLinkState_unstable)(state);
    return state;
}; //# sourceMappingURL=useLink.js.map

//# sourceMappingURL=useLink.js.map